import { z } from "zod";

export const ConfigSchema = z.object({
  code: z.string().min(1, "Veuillez renseigner le code de la configuration."),
  name: z.string().min(1, "Veuillez renseigner le nom de la configuration."),
  value: z.string().min(1, "Veuillez renseigner la valeur de la configuration.")
});

export type ConfigSchema = z.infer<typeof ConfigSchema>;
